import {useFluxStore} from 'client/framework';
import {useMemo} from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import {getClassroomsQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import sessionStore from 'client/Session/SessionStore';
import {useStudentHomepageStore} from '../../useStudentHomepageStore';

export default function useClassrooms() {
  const areClassroomsLoading = useStudentHomepageStore((state) => state.areClassroomsLoading);
  const classrooms = useStudentHomepageStore((state) => state.classrooms);
  const setAreClassroomsLoading = useStudentHomepageStore((state) => state.setAreClassroomsLoading);
  const setClassrooms = useStudentHomepageStore((state) => state.setClassrooms);
  const studentId = useFluxStore(sessionStore, (s) => s.getUserId());

  const query = useMemo(() => getClassroomsQuery(studentId), [studentId]);

  function fetchClassrooms() {
    setAreClassroomsLoading(true);

    query.invalidateInterest();

    query
      .getResourcePromise()
      .then((fetchedClassrooms) => {
        setClassrooms(fetchedClassrooms);
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      })
      .finally(() => {
        setAreClassroomsLoading(false);
      });
  }

  return {areClassroomsLoading, classrooms, fetchClassrooms};
}
